<div class="courses">
  <div
    class="cards-container"
    role="list"
    [ngClass]="{
      'snake-layout': layoutView === 'SnakeView',
      'grid-layout': layoutView === 'CardView',
      'list-layout': layoutView === 'ListView' || layoutView === 'NumberedListView',
    }"
  >
    @for (card of cards; track card._id + '_' + $index; let i = $index) {
      <ptl-card-item
        role="listitem"
        class="card-item"
        [card]="card"
        [cardIndex]="i"
        [viewType]="layoutView"
        [reservedRows]="reservedRows"
        (cardClick)="onCardClick($event)"
      ></ptl-card-item>
    }
  </div>
</div>
